import React, { useEffect } from "react";
import Image from "next/legacy/image";
import cx from "classnames";
import { IWalletComponent } from "@novel/shared/components/ConnectWalletComponent/types";
import { useAsyncCallback } from "@novel/shared/utils/useAsyncCallback";
import { AuthWallet } from "@novel/shared/utils/wallets/AuthWallet";
import Solana from "@novel/shared/icons/solana.svg";
import { PhantomWindow, scopePollingDetectionStrategy } from "@novel/shared/utils/wallets/walletLibInstances";
export function PhantomWalletComponent({
  onConnectWallet,
  disabled,
  isInGate,
  AuthWalletClass = AuthWallet
}: IWalletComponent): JSX.Element {
  const connectPhantom = useAsyncCallback(async () => {
    await new AuthWalletClass("phantom").ensureWalletAppInstalled(async wallet => onConnectWallet(await wallet.authenticate()));
  }, [onConnectWallet]);
  useEffect(() => {
    scopePollingDetectionStrategy(() => {
      if ((window as PhantomWindow).phantom?.solana?.isPhantom || (window as PhantomWindow).solana?.isPhantom) {
        return true;
      }
      return false;
    });
  }, []);
  return <div className={cx("connect-wallet-button", isInGate && "connect-wallet-button-in-gate", disabled ? "connect-wallet-button-unvailable" : "")} onClick={disabled ? undefined : connectPhantom}>
            {isInGate ? <img src={Solana} height="50px" width="50px" /> : <Image alt="phantom" src={Solana} layout="fixed" />}
            {isInGate ? <div className="connect-wallet-name-description-updated">
                    <span className="Connect-title-field-updated">Phantom</span>
                </div> : <div className="connect-wallet-name-description">
                    <span className="Connect-title-field">Phantom</span>
                    <div className="connect-wallet-explanation-text">Solana Only</div>
                </div>}
        </div>;
}